<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;" width="300">
			<v-list>
				<v-list-group v-for="item in items" :key="item.title"
					v-model="item.active"
					:prepend-icon="item.icon"
					no-action
				>
					<template v-slot:activator>
						<v-list-item-content>
							<v-list-item-title v-text="item.title"></v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-for="child in item.items" :key="child.title" :to="child.to">
						<v-list-item-icon>
							<v-icon v-text="child.icon"></v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title v-text="child.title"></v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>
			</v-list>
			<!-- <v-card flat>
				<v-card-text>
					
				</v-card-text>
			</v-card> -->
			<!-- <template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template> -->
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right floating
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			
        </v-navigation-drawer>

		<v-container style="padding: 0px 256px 0px 256px;">
			<!-- <vue-markdown :source="src" /> -->
		</v-container>
		<!-- <v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay> -->
		<!-- <v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar> -->

		<!-- <z-pdf ref="pdf" :item="item"></z-pdf> -->
	</v-main>
</template>

<script>
import { mapGetters } from 'vuex'
//import VueMarkdown from 'markdown-it'
//import VueMarkdown from 'vue-markdown-render'
import zPdf from '@/views/pdf/VehicleAveragePriceAI'
import downloadExcel from "vue-json-excel";

export default {
	name: 'Help',
	components: {
		//VueMarkdown, 
		zPdf,
	},
	data: () => ({
		title: 'КАСКО калькулятор',
		subtitle: 'Розрахунок вартісті добровільного страхування автомобіля',
		icon: 'mdi-calculator',
	}),

	props: {
		doc:   	{ type: String, default: 'Help' },
	},

	computed: {
		...mapGetters('Help', [ 'items' ]),
	},

	methods: {
		onPDF () {
			//this.$refs.pdf.generate()
		},
	},
}
</script>